import React from "react";

const Terms = () => {
  return (
    <div style={{ padding: 30 }}>
      <h1>Terms & Conditions</h1>

      <p>
        By using PrintMyCake, you agree to use the service for lawful purposes only.
      </p>

      <p>
        Orders once printed cannot be cancelled.
      </p>

      <p>
        We are not responsible for low quality images uploaded by users.
      </p>

      <p>
        Delivery timelines may vary depending on order volume.
      </p>
    </div>
  );
};

export default Terms;